import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import Intake from './components/Intake';
import IntakeForm from './components/IntakeForm';
import AIContent from './components/AIContent';
import Chatbot from './components/Chatbot';
import LivePortrait from './components/LivePortrait';
import GenerateLivePortrait from './components/GenerateLivePortrait';
import LPUpload from './components/LPUpload';
import Captcha from './components/Captcha';
import Output from './components/Output';
import AIAIAIDashboard from './components/AIAIAIDashboard';
import ParticipantsPage from './components/ParticipantsPage';
import DeelnemersGallery from './components/DeelnemersGallery';
function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/intake-form"
          element={
            <div className="App container">
              <IntakeForm />
            </div>
          }
        />
        <Route
          path="/intake"
          element={
            <div className="App container">
              <Intake />
            </div>
          }
        />
        <Route
          path="/ai-content"
          element={
            <div className="App container">
              <AIContent />
            </div>
          }
        />
        <Route
          path="/lp-upload"
          element={
            <div className="App container">
              <LPUpload />
            </div>
          }
        />
        <Route
          path="/live-portrait"
          element={
            <div className="App container">
              <LivePortrait />
            </div>
          }
        />
        <Route
          path="/chatbot"
          element={
            <div className="App container">
              <Chatbot />
            </div>
          }
        />
        <Route
          path="/aiaiai-dashboard"
          element={
            <AIAIAIDashboard />
          }
        />
        <Route
          path="/deelnemers"
          element={
            <div className="App container">
              <ParticipantsPage />
            </div>
          }
        />
        <Route
          path="/deelnemers-gallery"
          element={
            <div className="App container">
              <DeelnemersGallery />
            </div>
          }
        />
        <Route
          path="/"
          element={
            <div className="App container" style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100vh"}}>
              <div style={{ textAlign: "center", fontSize: "2em" }}>
                <div style={{ margin: "0.5em" }}><Link to="/chatbot">Chatbot</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/ai-content">AI Content</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/live-portrait">Live Portrait</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/captcha">Captcha</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/deelnemers">Participants list</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/aiaiai-dashboard">AIAIAI Dashboard</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/lp-upload">Live Portrait Upload</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/deelnemers-gallery">Deelnemers Gallery</Link></div>
              </div>
            </div>
          }
        />
        <Route
          path="*"
          element={
            <div className="App container" style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100vh"}}>
              <div style={{ textAlign: "center", fontSize: "2em" }}>
                <div style={{ margin: "0.5em" }}><Link to="/chatbot">Chatbot</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/ai-content">AI Content</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/live-portrait">Live Portrait</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/captcha">Captcha</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/deelnemers">Participants list</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/aiaiai-dashboard">AIAIAI Dashboard</Link></div>
                <div style={{ margin: "0.5em" }}><Link to="/lp-upload">Live Portrait Upload</Link></div>
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
